<template>
  <div class="container-fluid">
    <vx-card :title="'Variables / Modelo de Pre-Aprobación'">
      <div class="row">
        <div class="col-md-12">
          <vs-table :data="[{}]" v-if="formError === ''">
            <vs-tr>
              <vs-td class="font-bold">Score</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.score|fixNumber}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Saldo vencido</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.due_balance|currency}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Saldo actual</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.current_balance|currency}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Pagos con atraso</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.payment_with_delay_historical}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Peor atraso</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.worst_delay}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Coincidencia PLD</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.pld_match|answerBoolean}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Clave prevención</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.prevention_key}}</vs-td>
            </vs-tr>
            <!-- financieros -->
            <vs-tr>
              <vs-td class="font-bold">Mayor crédito aprobado</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.higher_approved_credit|currency}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">¿Mayor crédito aprobado liquidado?</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.is_settled_higher_approved_credit|answerBoolean}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Factura RG</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.total_cost|currency}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Total pago actual reportado</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.total_current_balance}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Fecha consulta</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.request_date|_humanizeDate}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Fecha apertura crédito mayor</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.higher_credit_opening_date|_humanizeDate}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Crédito mayor liquidado</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.higher_credit_opening_amount|currency}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">No. Consultas</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.request_quantity}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Créditos aprobados</vs-td>
              <vs-td class="text-right">{{request.cdc_resume.approved_credits}}</vs-td>
            </vs-tr>
            <!-- ekatena -->
            <vs-tr>
              <vs-td class="font-bold">¿Tiene demadas?</vs-td>
              <vs-td class="text-right">{{request.ekatena_resume.has_legal_claims|answerBoolean}}</vs-td>
            </vs-tr>
            <template v-if="request.ekatena_resume.has_legal_claims">
              <vs-tr>
                <vs-td class="font-bold">Tipo de demanda determinada</vs-td>
                <vs-td class="text-right">{{getClaimType(request.ekatena_resume.legal_claim_type)}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="font-bold">Cantidad de demandas</vs-td>
                <vs-td class="text-right">{{request.ekatena_resume.legal_claims_quantity}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="font-bold">Ultima notificación (más reciente)</vs-td>
                <vs-td class="text-right">{{request.ekatena_resume.latest_legal_claims_notification_date|_humanizeDate}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="font-bold">Actor</vs-td>
                <vs-td class="text-right">{{getActorName(request.ekatena_resume.sued_against)}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <vs-alert v-else color="danger">{{formError}}</vs-alert>
        </div>
      </div>

      <!--<div class="row">
        <div class="col-md-12">
          <vs-button @click="buildSchema()">Schema</vs-button>
        </div>
      </div>-->
    </vx-card>
  </div>
</template>

<script>
import {fixNumber} from "@/filters/NumberFilters";
import {_humanizeDate} from '@/filters/momentTzConvert'
import {InMemoryActorRepository} from "@/models/SuedAgainst/InMemoryActorRepository";
import {InMemoryClaimTypeRepo} from "@/models/ClaimTypes/InMemoryClaimTypeRepo";

export default {
  name: "PreApproveModelRiskForm",
  data: () => ({
    formError: "",
    request: {
      cdc_resume: {
        score: null,
        due_balance: null,
        current_balance: null,
        total_current_balance: null,
        payment_with_delay_historical: null,
        pld_match: null,
        late_payments: null,
        worst_delay: null,
        prevention_key: null,
        higher_credit_opening_amount: null,
        is_settled_higher_approved_credit: null,
        request_date: null,
        higher_credit_opening_date: null,
        higher_approved_credit: null,
        request_quantity: null,
        approved_credits: null
      },
      ekatena_resume: {
        has_legal_claims: null,
        legal_claim_type: null,
        legal_claims_quantity: null,
        latest_legal_claims_notification_date: null,
        sued_against: null,
      }
    },
    result: {}
  }),
  async mounted() {
    await this.main();
  },
  filters: {
    fixNumber,
    _humanizeDate,
    answerBoolean(val) {
      return val ? 'Sí': 'No';
    }
  },
  methods: {
    async main() {
      let projectId = this.$route.params.id;
      this.$vs.loading();

      try {
        const {data} = await axios.post(`/api/risk-model/pre-approve/form`, {
          projectId: projectId
        })
        this.request = data;
        this.$emit("onLoaded", true)
      } catch (e) {
        this.$emit("hasError", e.response.data)
        this.formError = e.response.data.error
      } finally {
        this.$vs.loading.close();
      }
    },
    async buildSchema() {
      this.$vs.loading();
      this.projectId = this.$route.params.id;

      try {
        const {data} = await axios.post(`/api/risk-model/${this.projectId}/pre-approve/build`, this.request)
        this.result = data;
        this.$emit("update:schema", data);
      } finally {
        this.$vs.loading.close();
      }
    },
    getActorName(actorId) {
      let actorRepository = new InMemoryActorRepository();
      let actor = actorRepository.getById(actorId);
      if(actor) {
        return actor.name;
      }
      return "";
    },
    getClaimType(claimTypeId) {
      let claimTypeRepository = new InMemoryClaimTypeRepo();
      let claimType = claimTypeRepository.getByClaimId(claimTypeId);
      if(claimType) {
        return claimType.name;
      }
      return "";
    }
  }
}
</script>

<style scoped>

</style>
